module.exports = __webpack_public_path__ + "img/pay_diagram.png";